
import * as Dto                          from '../dtos'; 
import { ProxyHttp } from '@wtw/platform/api';
import { Injectable }                    from '@angular/core';
import { Observable }                    from 'rxjs';
import { ApiResult,BinaryTransferObject} from '@wtw/platform/api';
import { map }                           from  'rxjs/operators';
export { ApiResult };

@Injectable()
export class ValidationProxy {
    	constructor(private _http: ProxyHttp) { 
        }
        
             
                updateClonedRun (runViewModel: Dto.RunViewModel, runId: number) : Observable<ApiResult<Dto.RunViewModel>> {
                return this._http.post(`/backend/validation/updateClonedRun/${runId}`,runViewModel||{}).pipe(map(ret=>({ data: ret.body, originalResponse: ret})));
	        }
             
        
}

	
